// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"5af154a6","90":"4b0e2d91","329":"5ff06472","458":"4b0e2d91"}[chunkId] + ".chunk.css";
};